import { designSystem } from '@/styles/theme';

/**
 * 날짜·시간 선택기 색 — 세미나 폼 시안(calmock·altmock) 값. 선택기는 어느 화면에 붙어도 이 색을 쓴다.
 */
export const PICKER_COLOR = {
  text: '#1F2A28',
  sub: '#4F5B58',
  muted: '#66736F',
  placeholder: '#9AA5A2',
  border: '#D3DBD8',
  line: '#E3E8E6',
  primary: designSystem.colors.primary, // #5A9B96
  primaryDeep: '#2F6B66',
  primarySoft: '#E6F1EF',
  primaryCard: '#F1F8F6',
  primaryDisabled: '#B8CFCB',
  /** 오류 빨강 — 한 가지만(UI 가이드 1장, 세미나 폼 FORM_COLOR.danger 와 같은 값) */
  danger: '#E11D48',
} as const;
